import React from 'react';
import logger from './utils/logger';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { router } from './router';
import { isThemePreviewOn, applyThemePreview } from './utils/themePreview';
import { hardRefreshApp, shouldSkipRecentChunkReload } from './utils/appVersion';

// Restore opt-in theme preview before first paint of React tree
applyThemePreview(isThemePreviewOn());

// Handle chunk loading errors (usually caused by cached old versions)
window.addEventListener('error', (event) => {
  const error = event.error;
  const filename = event.filename || '';

  // Ignore errors from browser extensions (e.g. chrome-extension://...)
  if (filename.startsWith('chrome-extension://')) {
    return;
  }
  // Check if it's a chunk loading error
  if (
    error && (
      error.name === 'ChunkLoadError' ||
  error.message?.includes('Loading chunk') || (
      // Only treat dynamic import failures for our own origin as chunk issues
        error.message?.includes('Failed to fetch dynamically imported module') &&
  filename.startsWith(window.location.origin)) || (
        error.message?.includes('Unexpected token') && filename.includes('.chunk.js')))) {
    logger.warn('Chunk loading error detected - likely due to cached old version:', {
      error: error.message,
      filename: event.filename,
      suggestion: 'Page will reload to fetch latest version'
    });

    if (shouldSkipRecentChunkReload()) {
      logger.warn('Skipping chunk reload loop (already reloaded within 15s)');
      return;
    }

    setTimeout(() => {
      hardRefreshApp();
    }, 1000);
  }
});

// Handle unhandled promise rejections for chunk loading
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason;
  const message = error?.message || '';

  // Ignore extension-originated dynamic import failures
  if (message.includes('chrome-extension://')) {
    return;
  }
  // Only treat real route chunk failures (not e.g. web-vitals or other optional dynamic imports)
  const isChunkLoadError =
  error && (
    error.name === 'ChunkLoadError' || (
      typeof message === 'string' &&
  message.includes('Loading chunk') &&
  !message.includes('chrome-extension://')));

  if (isChunkLoadError) {
    logger.warn('Chunk loading error in promise rejection - likely due to cached old version:', {
      error: error.message,
      suggestion: 'Page will reload to fetch latest version'
    });

    event.preventDefault(); // Prevent default error handling

    if (shouldSkipRecentChunkReload()) {
      logger.warn('Skipping chunk reload loop (already reloaded within 15s)');
      return;
    }

    setTimeout(() => {
      hardRefreshApp();
    }, 1000);
  }
});

// Initialize app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// Report web vitals
reportWebVitals(logger.debug);
